import { Mail, MapPin, Phone, Globe, Shield } from 'lucide-react'

// Brand sito
const SITE_NAME = 'Valutazioni Immobili Assemini'

// Agenzia di riferimento
const REF_AGENCY_NAME = 'L.A. di Elia Soddu'
const REF_AGENCY_ADDRESS = 'Via Sicilia, 22'
const REF_AGENCY_CITY = 'Assemini (CA)'
const REF_AGENCY_PHONE = '+39 3288820738'
const REF_AGENCY_EMAIL = 'l.aimm@hotmail.it'
const REF_AGENCY_WEBSITE = 'https://www.laimmobiliare.net'

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h2 className="text-xl font-bold text-white mb-4">{SITE_NAME}</h2>
            <p className="text-sm text-gray-400">
              Valutazioni immobiliari professionali basate sui dati reali
              del compravenduto degli ultimi 12 mesi nella zona metropolitana di Cagliari.
            </p>
          </div>

          {/* Agenzia di riferimento */}
          <div>
            <h3 className="text-white font-semibold mb-4">Agenzia di riferimento</h3>
            <p className="text-sm text-white font-medium">{REF_AGENCY_NAME}</p>
            <p className="text-xs text-gray-400 mb-3">L.A. immobiliare</p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-primary-500 mt-0.5 shrink-0" />
                <span>
                  {REF_AGENCY_ADDRESS}<br />
                  {REF_AGENCY_CITY}
                </span>
              </li>
              <li>
                <a href={`tel:${REF_AGENCY_PHONE.replace(/\s/g, '')}`} className="flex items-center gap-2 hover:text-white transition-colors">
                  <Phone className="h-4 w-4 text-primary-500" />
                  {REF_AGENCY_PHONE}
                </a>
              </li>
              <li>
                <a href={`mailto:${REF_AGENCY_EMAIL}`} className="flex items-center gap-2 hover:text-white transition-colors">
                  <Mail className="h-4 w-4 text-primary-500" />
                  {REF_AGENCY_EMAIL}
                </a>
              </li>
              <li>
                <a href={REF_AGENCY_WEBSITE} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors">
                  <Globe className="h-4 w-4 text-primary-500" />
                  www.laimmobiliare.net
                </a>
              </li>
            </ul>
          </div>

          {/* Disclaimer */}
          <div>
            <h3 className="text-white font-semibold mb-4">Note legali</h3>
            <div className="space-y-3 text-sm text-gray-400">
              <p className="flex items-start gap-2">
                <Shield className="h-4 w-4 text-primary-500 mt-0.5 shrink-0" />
                <span>Dati tratti dal compravenduto degli ultimi 12 mesi</span>
              </p>
              <p>
                Le valutazioni fornite sono indicative e basate su dati statistici.
                Non costituiscono perizia estimativa ufficiale.
              </p>
              <p className="text-primary-400 font-medium">
                Per una valutazione professionale, contatta la nostra agenzia di riferimento.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500 space-y-1">
          <p>© {new Date().getFullYear()} {SITE_NAME} - Tutti i diritti riservati</p>
          <p>
            Software sviluppato da Andrea Piani —{' '}
            <a
              href="https://www.andreapiani.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors underline"
            >
              www.andreapiani.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}
